export function isTouchesInsideRect(touches: any, rect: any) {
    return Array.prototype.every.call(
        touches,
        (touch: any) =>
            touch.clientX <= rect.right &&
            touch.clientX >= rect.left &&
            touch.clientY <= rect.bottom &&
            touch.clientY >= rect.top
    );
}
